import { forEach } from "lodash";

export const TIER1 = "tier1";
export const TIER2 = "tier2";
export const TIER3 = "tier3";
export const CUSTOM_TIER = "custom";

export interface TierOption {
  label: string;
  value: string;
}

export const TIER_OPTIONS: TierOption[] = [
  {
    label: "Tier 1",
    value: TIER1,
  },
  {
    label: "Tier 2",
    value: TIER2,
  },
  {
    label: "Tier 3",
    value: TIER3,
  },
];

export const TIER_OPTIONS_WITH_CUSTOM: TierOption[] = [
  ...TIER_OPTIONS,
  { label: "Custom", value: CUSTOM_TIER },
];

export interface TagObj {
  name: string;
  fieldValue?: string;
}

export function getTagKey(tagObj: TagObj): string {
  const { name, fieldValue } = tagObj;
  if (fieldValue) {
    return `${name}:${fieldValue}`;
  }
  return name;
}

export function getTagKeyMap(allTags: TagObj[]): Record<string, TagObj> {
  const allTagsMap: Record<string, TagObj> = {};
  forEach(allTags, (tagObj) => {
    allTagsMap[getTagKey(tagObj)] = tagObj;
  });
  return allTagsMap;
}
